document.addEventListener('DOMContentLoaded', function () {

  /* Mobile drawer */
  var drawer = document.querySelector('[data-mobile-drawer]');
  document.querySelectorAll('[data-drawer-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (drawer) drawer.classList.add('open');
    });
  });
  document.querySelectorAll('[data-drawer-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (drawer) drawer.classList.remove('open');
    });
  });

  /* Mobile drawer nested menu accordion */
  document.querySelectorAll('[data-drawer-accordion-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.drawer-item');
      if (item) item.classList.toggle('open');
    });
  });

  /* Accordions (product details) */
  document.querySelectorAll('[data-accordion-group]').forEach(function (group) {
    var heads = group.querySelectorAll('.acc-head');
    heads.forEach(function (head) {
      head.addEventListener('click', function () {
        var item = head.closest('.acc-item');
        var wasOpen = item.classList.contains('open');
        group.querySelectorAll('.acc-item').forEach(function (i) { i.classList.remove('open'); });
        if (!wasOpen) item.classList.add('open');
      });
    });
  });

  /* Product gallery thumbnail swap */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var mainImg = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (mainImg) mainImg.src = thumb.getAttribute('data-full');
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });
  });

  /* Quantity steppers */
  document.querySelectorAll('[data-qty-wrap]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('[data-qty-minus]').forEach(function (b) {
      b.addEventListener('click', function () {
        input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
      });
    });
    wrap.querySelectorAll('[data-qty-plus]').forEach(function (b) {
      b.addEventListener('click', function () {
        input.value = parseInt(input.value || '1', 10) + 1;
      });
    });
  });

  /* Product option swatches -> update hidden variant id + price + availability */
  document.querySelectorAll('[data-product-form]').forEach(function (formEl) {
    var variantsJson = formEl.getAttribute('data-variants');
    var variants = [];
    try { variants = JSON.parse(variantsJson); } catch (e) { variants = []; }
    var optionInputs = formEl.querySelectorAll('[data-option-index]');
    var variantIdInput = formEl.querySelector('[data-variant-id-input]');
    var priceEl = formEl.querySelector('[data-price-display]');
    var compareEl = formEl.querySelector('[data-compare-display]');
    var addBtn = formEl.querySelector('[data-add-to-cart]');

    function currentSelection() {
      var groups = {};
      formEl.querySelectorAll('[data-option-index].active').forEach(function (el) {
        groups[el.getAttribute('data-option-index')] = el.getAttribute('data-value');
      });
      return groups;
    }

    function findVariant() {
      var sel = currentSelection();
      return variants.find(function (v) {
        return Object.keys(sel).every(function (idx) {
          return v['option' + (parseInt(idx, 10) + 1)] === sel[idx];
        });
      });
    }

    function updateUI() {
      var variant = findVariant();
      if (!variant) return;
      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available
          ? (addBtn.getAttribute('data-label-add') || 'Add to cart') + ' \u2014 ' + formatMoney(variant.price)
          : 'Sold out';
      }
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    optionInputs.forEach(function (el) {
      el.addEventListener('click', function () {
        var idx = el.getAttribute('data-option-index');
        formEl.querySelectorAll('[data-option-index="' + idx + '"]').forEach(function (sib) {
          sib.classList.remove('active');
        });
        el.classList.add('active');
        updateUI();
      });
    });

    updateUI();
  });

  /* Ajax add to cart (product form + quick add buttons) */
  function ajaxAddToCart(formData, onDone) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(formData)
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        updateCartCount();
        if (onDone) onDone(null, data);
      })
      .catch(function (err) {
        if (onDone) onDone(err);
      });
  }
  document.querySelectorAll('[data-routine-add]').forEach(function (btn) {
  btn.addEventListener('click', function () {
    var variantsAttr = btn.getAttribute('data-routine-variants') || '';
    var variantIds = variantsAttr
      .split(',')
      .map(function (id) { return id.trim(); })
      .filter(function (id) { return id.length > 0; });

    if (!variantIds.length) {
      var note = btn.parentElement.querySelector('[data-routine-note]');
      if (note) {
        note.textContent = 'Something went wrong - no products found to add.';
        note.classList.add('show');
      }
      return;
    }

    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    var items = variantIds.map(function (id) {
      return { id: id, quantity: 1 };
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (errData) {
            throw new Error(errData.description || 'Could not add all items to cart.');
          });
        }
        return res.json();
      })
      .then(function () {
        if (typeof updateCartCount === 'function') {
          updateCartCount();
        } else {
          fetch('/cart.js')
            .then(function (res) { return res.json(); })
            .then(function (cart) {
              document.querySelectorAll('.cart-count').forEach(function (el) {
                el.textContent = cart.item_count;
              });
            });
        }

        btn.textContent = 'Added to Cart';
        var note = btn.parentElement.querySelector('[data-routine-note]');
        if (note) {
          note.textContent = 'Routine added to your bag.';
          note.classList.add('show');
          setTimeout(function () { note.classList.remove('show'); }, 3000);
        }

document.dispatchEvent(new CustomEvent('routine:added', {
  detail: { variantIds: variantIds }
}));
        setTimeout(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1800);
      })
      .catch(function (err) {
        btn.textContent = 'Try again';
        var note = btn.parentElement.querySelector('[data-routine-note]');
        if (note) {
          note.textContent = err.message || 'Something went wrong. Please try again.';
          note.classList.add('show');
        }
        setTimeout(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1800);
      });
  });
});

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
        });
              });
  }
function formatMoneyCartPopup(cents) {
  return '$' + (Number(cents) / 100).toFixed(2);
}

function renderCartPopup(cart, justAddedVariantId) {
  var overlay = document.querySelector('[data-cart-popup-overlay]');
  var popup = document.querySelector('[data-cart-popup]');
  if (!overlay || !popup) return;

  var addedImage = popup.querySelector('[data-cart-popup-added-image]');
  var addedTitle = popup.querySelector('[data-cart-popup-added-title]');
  var addedQty = popup.querySelector('[data-cart-popup-added-qty]');
  var shippingNote = popup.querySelector('[data-cart-popup-shipping-note]');
  var list = popup.querySelector('[data-cart-popup-list]');
  var countEl = popup.querySelector('[data-cart-popup-count]');
  var totalEl = popup.querySelector('[data-cart-popup-total]');

  var justAddedItem = null;
  if (justAddedVariantId) {
    justAddedItem = cart.items.find(function (item) {
      return String(item.variant_id) === String(justAddedVariantId);
    });
  }
  if (!justAddedItem && cart.items.length) {
    justAddedItem = cart.items[cart.items.length - 1];
  }

  if (justAddedItem) {
    addedImage.innerHTML = '';
    if (justAddedItem.image) {
      var img = document.createElement('img');
      img.src = justAddedItem.image;
      img.alt = justAddedItem.product_title;
      addedImage.appendChild(img);
    }
    addedTitle.textContent = justAddedItem.product_title;
    addedQty.textContent = 'Quantity: ' + justAddedItem.quantity;
  } else {
    addedImage.innerHTML = '';
    addedTitle.textContent = '';
    addedQty.textContent = '';
  }

  var freeShippingThresholdCents = 7500;
  if (cart.total_price >= freeShippingThresholdCents) {
    shippingNote.textContent = 'Your order qualifies for free shipping.';
  } else {
    shippingNote.textContent = '';
  }

  list.innerHTML = '';
  cart.items.forEach(function (item) {
    var li = document.createElement('li');
    li.className = 'cart-popup-list-item';

    var imgWrap = document.createElement('div');
    imgWrap.className = 'cart-popup-list-img';
    if (item.image) {
      var itemImg = document.createElement('img');
      itemImg.src = item.image;
      itemImg.alt = item.product_title;
      imgWrap.appendChild(itemImg);
    }

    var info = document.createElement('div');
    info.className = 'cart-popup-list-info';

    var titleEl = document.createElement('div');
    titleEl.className = 'cart-popup-list-title';
    titleEl.textContent = item.product_title;

    var metaEl = document.createElement('div');
    metaEl.className = 'cart-popup-list-meta';
    var priceEach = document.createElement('strong');
    priceEach.textContent = formatMoneyCartPopup(item.final_price);
    metaEl.appendChild(priceEach);
    metaEl.appendChild(document.createTextNode(' x ' + item.quantity));

    info.appendChild(titleEl);
    info.appendChild(metaEl);

    var removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = 'cart-popup-list-remove';
    removeBtn.setAttribute('aria-label', 'Remove ' + item.product_title);
    removeBtn.textContent = 'Remove';
    removeBtn.addEventListener('click', function () {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: 0 })
      })
        .then(function (res) { return res.json(); })
        .then(function (updatedCart) {
          if (typeof updateCartCount === 'function') updateCartCount();
          renderCartPopup(updatedCart, null);
        });
    });

    li.appendChild(imgWrap);
    li.appendChild(info);
    li.appendChild(removeBtn);
    list.appendChild(li);
  });

  countEl.textContent = cart.item_count;
  totalEl.textContent = formatMoneyCartPopup(cart.total_price);

  overlay.hidden = false;
  popup.hidden = false;
}

function showCartPopup(justAddedVariantId) {
  fetch('/cart.js')
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      renderCartPopup(cart, justAddedVariantId);
    });
}

function hideCartPopup() {
  var overlay = document.querySelector('[data-cart-popup-overlay]');
  var popup = document.querySelector('[data-cart-popup]');
  if (overlay) overlay.hidden = true;
  if (popup) popup.hidden = true;
}

document.addEventListener('click', function (e) {
  if (e.target.matches('[data-cart-popup-close]') || e.target.matches('[data-cart-popup-overlay]')) {
    hideCartPopup();
  }
});
document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') hideCartPopup();
});

if (typeof ajaxAddToCart === 'function') {
  var _originalAjaxAddToCart = ajaxAddToCart;
  ajaxAddToCart = function (formData, onDone) {
    _originalAjaxAddToCart(formData, function (err, data) {
      if (!err) {
        var addedVariantId = (data && data.items && data.items[0] && data.items[0].variant_id) ||
          (formData && formData.id) ||
          (formData && formData.items && formData.items[0] && formData.items[0].id);
        showCartPopup(addedVariantId);
      }
      if (onDone) onDone(err, data);
    });
  };
}

document.addEventListener('routine:added', function (e) {
  var firstVariantId = e.detail && e.detail.variantIds && e.detail.variantIds[0];
  showCartPopup(firstVariantId);
});

  document.querySelectorAll('[data-product-form]').forEach(function (formEl) {
    formEl.addEventListener('submit', function (e) {
      e.preventDefault();
      var variantInput = formEl.querySelector('[data-variant-id-input]');
      var qtyInput = formEl.querySelector('[data-qty-input]');
      var note = formEl.querySelector('[data-add-note]');
      var payload = {
        id: variantInput ? variantInput.value : null,
        quantity: qtyInput ? parseInt(qtyInput.value, 10) : 1
      };
      var props = {};
      formEl.querySelectorAll('[name^="properties["]').forEach(function (el) {
        var m = el.name.match(/^properties\[(.+)\]$/);
        if (!m) return;
        if (el.type === 'checkbox' && !el.checked) return;
        if (el.value && el.value.trim() !== '') props[m[1]] = el.value.trim();
      });
      if (props['Gift message'] && !props['Gift']) props['Gift'] = 'Yes';
      if (Object.keys(props).length) payload.properties = props;
      ajaxAddToCart(payload, function (err) {
        if (note) {
          note.textContent = err ? 'Something went wrong. Please try again.' : 'Added to your bag.';
          note.classList.add('show');
          setTimeout(function () { note.classList.remove('show'); }, 3000);
        }
      });
    });
  });

  document.querySelectorAll('[data-quick-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var variantId = btn.getAttribute('data-variant-id');
      var original = btn.textContent;
      ajaxAddToCart({ id: variantId, quantity: 1 }, function (err) {
        btn.textContent = err ? 'Try again' : 'Added';
        setTimeout(function () { btn.textContent = original; }, 1800);
      });
    });
  });

  /* Testimonial rotators */
  document.querySelectorAll('[data-testimonial-rotator]').forEach(function (rotator) {
    var quoteText = rotator.querySelector('[data-quote-text]');
    var quoteCite = rotator.querySelector('[data-quote-cite]');
    var dotsWrap = rotator.querySelector('[data-dots]');

    var items = [];
    try {
      items = JSON.parse(rotator.getAttribute('data-quotes') || '[]');
    } catch (e) {
      console.warn('Testimonial rotator: could not parse data-quotes JSON, skipping this rotator.', e);
      items = [];
    }
    if (!items.length) return;
    var active = 0;

    items.forEach(function (_, i) {
      var d = document.createElement('button');
      d.className = 'dot' + (i === 0 ? ' active' : '');
      d.setAttribute('aria-label', 'Show testimonial ' + (i + 1));
      d.addEventListener('click', function () { setQuote(i); });
      dotsWrap.appendChild(d);
    });

    function setQuote(i) {
      active = i;
      quoteText.textContent = items[i].text;
      quoteCite.textContent = items[i].cite;
      dotsWrap.querySelectorAll('.dot').forEach(function (d, idx) {
        d.classList.toggle('active', idx === i);
      });
    }

    setInterval(function () { setQuote((active + 1) % items.length); }, 6000);
  });

  /* Collection: mobile filter toggle */
  document.querySelectorAll('[data-mobile-filter-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var sidebar = document.querySelector('.sidebar');
      if (sidebar) sidebar.classList.toggle('mobile-open');
    });
  });

  /* Collection: sort select updates URL param */
  document.querySelectorAll('[data-sort-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.href = url.toString();
    });
  });

  /* Product recommendations (native Shopify recommendations API) */
  var recSection = document.querySelector('[data-recommendations]');
  if (recSection) {
    var url = recSection.getAttribute('data-url');
    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var content = tmp.querySelector('[data-recommendations]');
        if (content && content.innerHTML.trim().length) {
          recSection.innerHTML = content.innerHTML;
        } else {
          recSection.closest('.related').style.display = 'none';
        }
      })
      .catch(function () {
        recSection.closest('.related').style.display = 'none';
      });
  }

  /* Header search toggle */
  document.querySelectorAll('[data-search-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = document.getElementById('header-search-panel');
      if (!panel) return;
      var isOpen = !panel.classList.contains('open');
      panel.classList.toggle('open', isOpen);
      panel.hidden = !isOpen;
      btn.setAttribute('aria-expanded', isOpen);
      if (isOpen) {
        var input = panel.querySelector('input[type="search"]');
        if (input) input.focus();
      }
    });
  });
  document.querySelectorAll('[data-search-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = document.getElementById('header-search-panel');
      if (!panel) return;
      panel.classList.remove('open');
      panel.hidden = true;
      var resultsBox = panel.querySelector('[data-predictive-search-results]');
      if (resultsBox) resultsBox.hidden = true;
    });
  });

  /* Predictive search: fetch + render dropdown as the user types. */
  document.querySelectorAll('[data-predictive-search-form]').forEach(function (form) {
    var input = form.querySelector('[data-predictive-search-input]');
    var resultsBox = form.parentElement.querySelector('[data-predictive-search-results]');
    if (!input || !resultsBox) return;

    var debounceTimer = null;
    var currentController = null;

    function formatMoney(amount) {
      /* NOTE: /search/suggest.json returns price as a plain decimal
         dollar string (e.g. "65.00"), unlike the Ajax Cart/product
         JSON APIs which use cents. So this does NOT divide by 100. */
      return '$' + Number(amount).toFixed(2);
    }

    function clearResults() {
      while (resultsBox.firstChild) {
        resultsBox.removeChild(resultsBox.firstChild);
      }
    }
    
    function renderLoading(term) {
      clearResults();
      var msg = document.createElement('div');
      msg.className = 'predictive-search-loading';
      msg.textContent = 'Searching\u2026';
      resultsBox.appendChild(msg);
      resultsBox.hidden = false;
    }

    function renderEmpty(term) {
      clearResults();
      var msg = document.createElement('div');
      msg.className = 'predictive-search-empty';
      msg.textContent = 'No results for \u201c' + term + '\u201d.';
      resultsBox.appendChild(msg);
      resultsBox.hidden = false;
    }

    function renderError(term) {
      clearResults();
      var msg = document.createElement('div');
      msg.className = 'predictive-search-empty';
      msg.textContent = 'Something went wrong. Try pressing enter to search.';
      resultsBox.appendChild(msg);
      resultsBox.hidden = false;
    }

    function renderResults(data, term) {
      var products = (data.resources && data.resources.results && data.resources.results.products) || [];
      if (!products.length) {
        renderEmpty(term);
        return;
      }

      clearResults();

      var list = document.createElement('div');
      list.className = 'predictive-search-list';

      products.forEach(function (product) {
        var imageUrl = product.featured_image ? product.featured_image.url : (product.image || '');
        var price = formatMoney(product.price);
        var showCompare = product.compare_at_price_max && Number(product.compare_at_price_max) > Number(product.price);

        var item = document.createElement('a');
        item.className = 'predictive-search-item';
        item.href = product.url;

        var imgWrap = document.createElement('span');
        imgWrap.className = 'predictive-search-item-image';
        if (imageUrl) {
          var img = document.createElement('img');
          img.src = imageUrl;
          img.alt = product.title;
          img.width = 100;
          img.height = 100;
          imgWrap.appendChild(img);
        }

        var info = document.createElement('span');
        info.className = 'predictive-search-item-info';

        var titleEl = document.createElement('span');
        titleEl.className = 'predictive-search-item-title';
        titleEl.textContent = product.title;

        var priceEl = document.createElement('span');
        priceEl.className = 'predictive-search-item-price';
        if (showCompare) {
          var wasEl = document.createElement('span');
          wasEl.className = 'was';
          wasEl.textContent = formatMoney(product.compare_at_price_max);
          priceEl.appendChild(wasEl);
          priceEl.appendChild(document.createTextNode(' '));
        }
        priceEl.appendChild(document.createTextNode(price));

        info.appendChild(titleEl);
        info.appendChild(priceEl);
        item.appendChild(imgWrap);
        item.appendChild(info);
        list.appendChild(item);
      });

      resultsBox.appendChild(list);

      var footer = document.createElement('div');
      footer.className = 'predictive-search-footer';

      var viewAllBtn = document.createElement('button');
      viewAllBtn.type = 'submit';
      viewAllBtn.textContent = 'View all results for \u201c' + term + '\u201d';
      viewAllBtn.addEventListener('click', function () {
        form.submit();
      });

      footer.appendChild(viewAllBtn);
      resultsBox.appendChild(footer);

      resultsBox.hidden = false;
    }

    function runSearch(term) {
      if (currentController) currentController.abort();
      currentController = new AbortController();

      renderLoading(term);

      var url = '/search/suggest.json?q=' + encodeURIComponent(term) +
        '&resources[type]=product&resources[limit]=6' +
        '&resources[options][unavailable_products]=last';

      fetch(url, { signal: currentController.signal })
        .then(function (res) { return res.json(); })
        .then(function (data) { renderResults(data, term); })
        .catch(function (err) {
          if (err.name === 'AbortError') return;
          renderError(term);
        });
    }

    input.addEventListener('input', function () {
      var term = input.value.trim();
      clearTimeout(debounceTimer);

      if (term.length < 2) {
        resultsBox.hidden = true;
        clearResults();
        return;
      }

      debounceTimer = setTimeout(function () {
        runSearch(term);
      }, 250);
    });

    /* Hide dropdown when clicking outside the search panel */
    document.addEventListener('click', function (e) {
      var panel = document.getElementById('header-search-panel');
      if (!panel || panel.hidden) return;
      if (!panel.contains(e.target)) {
        resultsBox.hidden = true;
      }
    });

    /* Hide dropdown on Escape */
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        resultsBox.hidden = true;
      }
    });
  });
});